import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then( m => m.AuthPageModule)
  },
  {
    path: 'folder',
    loadChildren: () => import('./folder/folder.module').then( m => m.FolderPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'intercity-bulky-goods',
    loadChildren: () => import('./intercity-bulky-goods/intercity-bulky-goods.module').then( m => m.IntercityBulkyGoodsPageModule)
  },
  {
    path: 'image-upload',
    loadChildren: () => import('./image-upload/image-upload.module').then( m => m.ImageUploadPageModule)
  },
  {
    path: 'vehicle',
    loadChildren: () => import('./vehicle/vehicle.module').then( m => m.VehiclePageModule)
  },
  {
    path: 'sender-receiver-details',
    loadChildren: () => import('./sender-receiver-details/sender-receiver-details.module').then( m => m.SenderReceiverDetailsPageModule)
  },
  {
    path: 'date-time',
    loadChildren: () => import('./date-time/date-time.module').then( m => m.DateTimePageModule)
  },
  {
    path: 'order-sumary',
    loadChildren: () => import('./order-sumary/order-sumary.module').then( m => m.OrderSumaryPageModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then( m => m.ProfilePageModule)
  },
  {
    path: 'proforma-invoice',
    loadChildren: () => import('./proforma-invoice/proforma-invoice.module').then( m => m.ProformaInvoicePageModule)
  },
  {
    path: 'tax-invoice',
    loadChildren: () => import('./tax-invoice/tax-invoice.module').then( m => m.TaxInvoicePageModule)
  },
  {
    path: 'twilio-video/:id/:dbkey',
    loadChildren: () => import('./twilio-video/twilio-video.module').then( m => m.TwilioVideoPageModule)
  },
  {
    path: 'location',
    loadChildren: () => import('./location/location.module').then( m => m.LocationPageModule)
  }


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
